export default {
  BESTSELLER: 'bestseller',
  HOT_ITEM: 'hotItem',
  TOP_PICK: 'topPick'
};
